import SoftwareWebinar from "./SoftwareWebinar";
import { WebinarPartsDummyData as WebinarData } from "./WebinarData";

export default function index() {
  return <SoftwareWebinar webinarData={WebinarData} />;
}
